// extracted by mini-css-extract-plugin
export default {"container":"KeyTakeaways_container__qdO0U","draggingOver":"KeyTakeaways_draggingOver__bxyiP","buttons":"KeyTakeaways_buttons__YQhPn"};